import { Chip } from "@material-ui/core";
import { green, grey, orange, red, yellow } from "@material-ui/core/colors";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import HelpIcon from "@material-ui/icons/Help";
import HourglassEmptyIcon from "@material-ui/icons/HourglassEmpty";
import WarningIcon from "@material-ui/icons/Warning";
import { get } from "lodash";
import React from "react";
import { useTranslate } from "react-admin";

const STATUS_COLOR_MAP = {
	none: grey[500],
	success: green[500],
	success_with_errors: orange[500],
	processing: yellow[800],
	error: red[500],
};
const STATUS_ICON_MAP = {
	none: HelpIcon,
	success: CheckCircleIcon,
	success_with_errors: CheckCircleIcon,
	processing: HourglassEmptyIcon,
	error: WarningIcon,
};

const SyncStatusField = ({ source, record }) => {
	const translate = useTranslate();
	const status = get(record, source);
	const color = get(STATUS_COLOR_MAP, status, "");
	const statusLabel = translate(`resources.bookmakers.sync_status.${status}`);
	const Icon = STATUS_ICON_MAP[status];
	return (
		<Chip
			icon={<Icon style={{ color: "white" }} />}
			label={statusLabel}
			style={{
				backgroundColor: color,
				color: "white",
			}}
		/>
	);
};
export default SyncStatusField;
